import { FunctionComponent, useEffect, useState } from "react";
import styles from "./ChangeOwnerModal.module.css";
import { setRefreshContacts, showSnackbarAction } from "../../../Redux/actions";
import Loading from "../../Loading/Loading";
import { connect, useDispatch } from 'react-redux';
import { functions } from "../../../Firebase";
import moment from "moment";
import { fetchTransferReason } from "../../../Services/resources";
import { datesField } from "../../../Values/tables";
import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import Modal, { Styles } from "react-modal";
import StyledCancelButton from "../../Buttons/StyledCancelButton";
import StyledSubmitButton from "../../Buttons/StyledSubmitButton";
import DropDown from "../../../Screens/LeadDistributorLogic/Dropdown"
import { Circles } from "react-loader-spinner";
import { themeColors } from "../../theme";
import "../../../theme-vars.css";


// -------------------------------------------
// Props Declaration
// -------------------------------------------
type props = {
  open: boolean;
  close: () => void;
  usersList: any;
  rowsSelected: any[];
  organization_id: string;
  clearSelectedRowsData?: () => void;
  freshFilterValue: string;
  theme: any;
};

// -------------------------------------------
// MAIN COMPONENT
// -------------------------------------------
const OwnerModal: FunctionComponent<props> = ({
  open,
  close,
  usersList,
  rowsSelected,
  clearSelectedRowsData,
  organization_id,
  freshFilterValue,
  theme
}) => {
  // -------------------------------------------
  // UI / Media Helpers
  // -------------------------------------------
  const themeMUI = useTheme();
  const isMobile = useMediaQuery(themeMUI.breakpoints.down("sm"));

  // -------------------------------------------
  // Component States
  // -------------------------------------------
  const [userIndex, setUserIndex] = useState(0);
  const [load, setLoad] = useState(false);
  const dispatcher = useDispatch();
  const [buttonType, setButtonType] = useState<any>("Next");

  const [fresh, setFresh] = useState(false);
  const [tasks, setTasks] = useState(false);
  const [notes, setNotes] = useState(false);
  const [attachments, setAttachments] = useState(false);
  const [contactDetails, setContactDetails] = useState(false);

  // Dropdown state
  const [reasons, setReasons] = useState<any[]>([]);
  const [reasonSelected, setReasonSelected] = useState<any>({ label: "Select", value: "Select" });
  const [ownerSelected, setOwnerSelected] = useState<any>({ label: "Select", value: "Select" });

  const [leadTypeList, setleadTypeList] = useState<any[]>(["Data", "Leads"]);
  const [leadTypeSelected, setLeadTypeSelected] = useState<any>({ label: "Select", value: "Select" });

  const [ownerList, setOwnerList] = useState<any[]>([]);
  const [leadsToTransfer, setLeadsToTransfer] = useState<any[]>([]);


  // -------------------------------------------
  // Auto-set Fresh Mode Based on Filter
  // -------------------------------------------
  useEffect(() => {
    if (freshFilterValue === "FRESH" || fresh === true) {
      setFresh(true);
      setContactDetails(true);
    }
    else {
      setFresh(false);
      setContactDetails(false);
    }
  }, [fresh, freshFilterValue]);

  // -------------------------------------------
  // Convert user objects into dropdown display format
  // -------------------------------------------
  useEffect(() => {
    let data: any = [];
    usersList.map((item: any, index: number) =>
      data.push(
        `${item.user_first_name} ${item.user_last_name} (${item.user_email})`
      )
    );
    setOwnerList(data);
  }, [usersList]);


  // -------------------------------------------
  // Map selected owner to actual user index
  // -------------------------------------------
  useEffect(() => {
    if (ownerSelected.value !== "") {
      let owner: any;
      usersList.map((item: any, index: number) => {
        owner = `${item.user_first_name} ${item.user_last_name} (${item.user_email})`;
        if (String(owner) === String(ownerSelected.value)) {
          setUserIndex(index + 1);
        }
      });
    }
  }, [ownerSelected]);

  // -------------------------------------------
  // Go to next step (Reason + Type selection)
  // -------------------------------------------
  const Next = () => {
    setButtonType("Change Owner");
    return {
      OwnerModal,
    };
  };

  // -------------------------------------------
  // Fetch Transfer Reasons based on org
  // -------------------------------------------
  useEffect(() => {
    const unsub = fetchTransferReason(
      organization_id,
      (data) => setReasons(data)
    );
    return () => {
      unsub();
    };
  }, [organization_id]);


  // -------------------------------------------
  // Convert Firestore Timestamp into string
  // -------------------------------------------
  useEffect(() => {
    let rowsList: any[] = [];
    rowsSelected.forEach((row) => {
      let newRow = { ...row };
      datesField.forEach((feild) => {
        if (
          newRow[feild] &&
          newRow[feild].toDate !== undefined
        ) {
          newRow[feild] = moment(
            newRow[feild].toDate()
          ).toString();
        }
      });
      rowsList.push(newRow);
    });
    setLeadsToTransfer(rowsList);
  }, [rowsSelected]);

  // -------------------------------------------
  // SUBMIT — Calls Firebase Cloud Function
  // -------------------------------------------
  const submit = async () => {
    // VALIDATION
    if (userIndex === 0) {
      dispatcher(
        showSnackbarAction("Select a User !!", "error")
      );
    } else if (
      reasonSelected.value === "" ||
      reasonSelected.value === "Select"
    ) {
      dispatcher(
        showSnackbarAction(
          "Please Select A Reason!!",
          "error"
        )
      );
    }
    else if (
      leadTypeSelected.value === "" ||
      leadTypeSelected.value === "Select"
    ) {
      dispatcher(
        showSnackbarAction(
          "Please Select Lead Type!!",
          "error"
        )
      );
    }
    else {
      setLoad(true);
      functions
        .httpsCallable("transferLead")({
          leadsData: leadsToTransfer,
          options: {
            fresh: fresh,
            notes: notes,
            attachments: attachments,
            task: tasks,
            contactDetails: contactDetails,
          },
          owner: {
            email:
              usersList[
                userIndex - 1
              ].user_email.toLowerCase(),
            uid: usersList[userIndex - 1].uid,
            organization_id:
              usersList[userIndex - 1].organization_id,
          },
          reason: reasonSelected.value,
          leadType: leadTypeSelected.value,
        })
        .then(() => {
          dispatcher(
            showSnackbarAction("Owner Updated!!", "success")
          );
          setLoad(false);
          close();
          clearSelectedRowsData && clearSelectedRowsData();
          setTimeout(() => {
            dispatcher(setRefreshContacts(true));
          }, 2500);
          window.location.reload();
        })
        .catch((error) => {
          console.log("owner change error:", error);
        });
    }
  };


  // -------------------------------------------
  // Custom Modal Styling (react-modal)
  // -------------------------------------------
  const modalStyle: Styles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1300,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      background: theme
        ? themeColors.cardBackgroundColor
        : themeColors.cardBackgroundColorDark,
      color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark,
      borderRadius: 16,
      padding: isMobile ? "24px 12px" : "40px 32px",
      width: 600,
      maxWidth: 700,
      border: "none",
      boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      position: "relative",
      inset: "auto",
      margin: "auto",
    },
  };

  // -------------------------------------------
  // UI (Two-step Modal)
  // -------------------------------------------
  return (
    <>
      {/* ------------------ STEP 2: REASON + LEAD TYPE ------------------ */}
      {buttonType == "Change Owner" && (
        <Modal
          isOpen={open}
          onRequestClose={close}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          style={modalStyle}
          ariaHideApp={false}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: 700,
              mx: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <form style={{ width: "100%" }}>
              <Grid container spacing={2} sx={{ width: "100%" }}>
                {/* Transfer Reason Dropdown */}
                <Grid item xs={12} sm={12}>
                  <DropDown
                    title="Select A Reason To Transfer"
                    option={reasons}
                    selectedValue={reasonSelected.value === "Select" ? "" : reasonSelected}
                    setSelectedValue={(value) => {
                      setReasonSelected(value);
                    }}
                    required={true}
                    maxWidth={520}
                  />
                </Grid>
                {/* Lead Type Dropdown */}
                <Grid item xs={12} sm={12}>
                  <DropDown
                    title="Please Select Lead Type"
                    option={leadTypeList}
                    selectedValue={leadTypeSelected.value === "Select" ? "" : leadTypeSelected}
                    setSelectedValue={(value) => {
                      setLeadTypeSelected(value);
                    }}
                    required={true}
                    maxWidth={520}
                  />
                </Grid>
              </Grid>
              {/* Submit Buttons */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 4,
                    width: "100%",
                  }}
                >
                  <Box style={{ marginRight: 8 }}>
                    <StyledCancelButton onClick={close} isMobile={isMobile}>
                      Cancel
                    </StyledCancelButton>
                  </Box>
                  <Box>
                    <StyledSubmitButton
                      onClick={submit}
                      themeMode={themeMUI.palette.mode}
                      isMobile={isMobile}
                    >
                      {load ? (
                        <span style={{ display: "flex", justifyContent: "center" }}>
                          <Circles color="#fff" height={20} width={20} />Changing
                        </span>
                      ) : (
                        <>Change</>
                      )}
                    </StyledSubmitButton>
                  </Box>
                </Box>
              </Grid>
            </form>
          </Box>
        </Modal>
      )}
      {/* ------------------ STEP 1: SELECT OWNER ------------------ */}
      {buttonType == "Next" && (
        <Modal
          isOpen={open}
          onRequestClose={close}
          shouldCloseOnOverlayClick={true}
          shouldCloseOnEsc={true}
          style={modalStyle}
          ariaHideApp={false}
        >
          {load && <Loading />}
          <Box
            sx={{
              width: "100%",
              maxWidth: 700,
              mx: "auto",
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <form style={{ width: "100%" }}>
              <Box sx={{ mb: 2 }}>
                {/* Title */}
                <h3
                  style={{
                    color: theme ? "#272944" : "#fff",
                    fontFamily: "var(--font-family-main)",
                    fontSize: "var(--font-size-large)",
                    marginBottom: 24,
                    textAlign: "center",
                    fontWeight: 700,
                    letterSpacing: 0.5,
                  }}
                >
                  Change Owner
                </h3>
              </Box>
              {/* Owner Selection */}
              <Grid container spacing={2} sx={{ width: "100%" }}>
                <Grid item xs={12}>
                  <DropDown
                    title="Choose Owner"
                    option={ownerList}
                    selectedValue={ownerSelected.value === "Select" ? "" : ownerSelected}
                    setSelectedValue={(value) => {
                      setOwnerSelected(value);
                    }}
                    required={true}
                    maxWidth={520}
                  />
                </Grid>
              </Grid>
              {/* Fresh Toggle */}
              <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                <p style={{ margin: 0, marginRight: 8 }}>
                  Do you want to transfer lead(s) As Fresh?
                </p>
                <input
                  onChange={(e) => {
                    setFresh(e.target.checked);
                    if (e.target.checked === true) {
                      setTasks(false);
                    }
                  }}
                  type="checkbox"
                  style={{ marginLeft: 4 }}
                  name="check"
                  checked={fresh}
                  disabled={freshFilterValue ? true : false}
                />
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                {/* Additional Options */}
                <p style={{ margin: 0, marginRight: 8 }}>
                  Select Options
                </p>
              </Box>

              {/* Only show tasks if not fresh */}
              {fresh === false && (
                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      setTasks(e.target.checked);
                    }}
                    style={{ marginRight: 6 }}
                  />
                  <p className={styles.optionText} style={{ margin: 0 }}>Open Tasks</p>
                </Box>
              )}

              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setNotes(e.target.checked);
                  }}
                  style={{ marginRight: 6 }}
                />
                <p className={styles.optionText} style={{ margin: 0 }}>Notes</p>
              </Box>

              <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setAttachments(e.target.checked);
                  }}
                  style={{ marginRight: 6 }}
                />
                <p className={styles.optionText} style={{ margin: 0 }}>Attachments</p>
              </Box>

              {fresh === true && (
                <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      setContactDetails(e.target.checked);
                    }}
                    checked={contactDetails || fresh}
                    style={{ marginRight: 6 }}
                  />
                  <p className={styles.optionText} style={{ margin: 0 }}>Contact Details</p>
                </Box>
              )}

              {/* Footer Buttons */}
              <Grid item xs={12}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 4,
                    width: "100%",
                  }}
                >
                  <Box style={{ marginRight: 8 }}>
                    <StyledCancelButton onClick={close} isMobile={isMobile}>
                      Cancel
                    </StyledCancelButton>
                  </Box>
                  <Box>
                    <StyledSubmitButton
                      onClick={Next}
                      themeMode={themeMUI.palette.mode}
                      isMobile={isMobile}
                    >
                      Next
                    </StyledSubmitButton>
                  </Box>
                </Box>
              </Grid>
            </form>
          </Box>
        </Modal>
      )}
    </>
  );
};

// Redux Connect
const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    theme: state.theme.isLightMode
  };
};
export default connect(mapStateToProps)(OwnerModal);

